module.exports = __webpack_public_path__ + "static/media/stripe.d78a5d3d.png";